import repositoryFactory from '@/helpers/api/apiFactory';
const api = repositoryFactory('charts');

const mainColors = {
    workload: "gold",
    denied: "#ff00008f",
    inability: '#dc3939', //"#ff00008f",
    canceled: "darkred",
    break: "#ffe31b94",
    inTheWay: "#5692ffb3",
    inactive: '#80808096',
    masters: 'blue',
    average: '#6a5dd8a3',
    transfer: '#f9ba46',
    traffic: '#3a3ad4',
    first_attempt: "green",//"#79b5ff",
    second_attempt: '#29942cb3',
    demand: '#8851a5'
};

const state = {
    show: false,
    checkboxes: [
        {key: 'canceled', value: 'Canceled'},
        {key: 'workload', value: 'Factual workload'},
        {key: 'denied', value: 'Denied'}
    ], 
    datasets: {
        hourly: [
            {
                yAxisID: "hour-traffic",
                type: 'line', 
                label: 'Traffic',
                backgroundColor: mainColors.traffic,
                borderColor: mainColors.traffic,
                data: [
                    14, 3, 10, 10, 17, 17,
                    17, 28, 25, 25
                ], 
                stack: 'Stack 3',
                fill: false,
            },
            {
                yAxisID: "hour-demand",
                type: 'line',
                name: 'demand',
                label: 'Demand',
                backgroundColor: mainColors.demand,
                borderColor: mainColors.demand,
                data: null, 
                stack: 'Stack 3',
                fill: false,
            },
            // stack 1 
            {
                name: 'sold',
                label: 'Factual workload',
                backgroundColor: mainColors.workload,
                borderColor: mainColors.workload,
                data: null, 
                stack: 'Stack 1',
            }, 
            {
                name: 'in_way',
                label: 'In the way',
                backgroundColor: mainColors.inTheWay,
                borderColor: mainColors.inTheWay,
                data: null, 
                stack: 'Stack 1',
            }, 
            {
                name: 'inactive',
                label: 'Inactive',
                backgroundColor: mainColors.inactive,
                borderColor: mainColors.inactive,
                data: null, 
                stack: 'Stack 1',
            }, 
            // stack 2 
            {
                name: 'first_attempt',
                label: 'First attempt',
                backgroundColor: mainColors.first_attempt,
                borderColor: mainColors.first_attempt,
                data: null, 
                stack: 'Stack 2',
            }, 
            {
                name: 'second_attempt',
                label: 'Second attempt',
                backgroundColor: mainColors.second_attempt,
                borderColor: mainColors.second_attempt,
                data: null, 
                stack: 'Stack 2',
            }, 
            {
                name: 'transfer',
                label: 'Transfer',
                backgroundColor: mainColors.transfer,
                borderColor: mainColors.transfer,
                data: null, 
                stack: 'Stack 2',
            },
            {
                name: 'canceled',
                label: 'Canceled by client',
                backgroundColor: mainColors.canceled,
                borderColor: mainColors.canceled,
                data: null, 
                stack: 'Stack 2',
            },
            {
                name: 'inability',
                label: 'DoS',
                backgroundColor: mainColors.inability,
                borderColor: mainColors.inability,
                data: null, 
                stack: 'Stack 2',
            } 
        ],
        daily: [
            // {
            //     type: 'line',
            //     name: 'demand',
            //     label: 'Demand',
            //     backgroundColor: mainColors.demand,
            //     borderColor: mainColors.demand,
            //     data: [12, 32, 3], 
            //     stack: 'Stack 4',
            //     fill: false,
            //     yAxisID: "day-demand",
            // },
            {
                type: 'line',
                name: 'traffic',
                label: 'Traffic',
                backgroundColor: mainColors.traffic,
                borderColor: mainColors.traffic,
                data: null, 
                stack: 'Stack 3',
                fill: false,
                yAxisID: "day-traffic",
            },
             
            // stack 1 
            {
                name: 'sold',
                label: 'Factual workload',
                backgroundColor: mainColors.workload,
                borderColor: mainColors.workload,
                data: null, 
                stack: 'Stack 1',
            }, 
            {
                name: 'in_way',
                label: 'In the way',
                backgroundColor: mainColors.inTheWay,
                borderColor: mainColors.inTheWay,
                data: null, 
                stack: 'Stack 1',
            }, 
            {
                name: 'inactive',
                label: 'Inactive',
                backgroundColor: mainColors.inactive,
                borderColor: mainColors.inactive,
                data: null, 
                stack: 'Stack 1',
            }, 
            // stack 2 
            {
                name: 'first_attempt',
                label: 'First attempt',
                backgroundColor: mainColors.first_attempt,
                borderColor: mainColors.first_attempt,
                data: null, 
                stack: 'Stack 2',
            }, 
            {
                name: 'second_attempt',
                label: 'Second attempt',
                backgroundColor: mainColors.second_attempt,
                borderColor: mainColors.second_attempt,
                data: null, 
                stack: 'Stack 2',
            }, 
            {
                name: 'transfer',
                label: 'Transfer',
                backgroundColor: mainColors.transfer,
                borderColor: mainColors.transfer,
                data: null, 
                stack: 'Stack 2',
            },
            {
                name: 'canceled',
                label: 'Canceled by client',
                backgroundColor: mainColors.canceled,
                borderColor: mainColors.canceled,
                data: null, 
                stack: 'Stack 2',
            },
            {
                name: 'inability',
                label: 'DoS',
                backgroundColor: mainColors.inability,
                borderColor: mainColors.inability,
                data: null, 
                stack: 'Stack 2',
            }     
        ], 
        sectors: [
            {
                type: 'line',
                label: 'Demand',
                backgroundColor: mainColors.demand,
                borderColor: mainColors.demand,
                data: [0, 20, 10, 0, 10], 
                fill: false,
                stack: 'Stack 2',
                name: 'demand'
            }, 
            {
                label: 'Handyman distribution',
                backgroundColor: mainColors.inability,
                borderColor: mainColors.inability,
                data: null, 
                stack: 'Stack 0',
                name: 'masters'
            },
            {
                label: 'Request distribution',
                backgroundColor: mainColors.workload,
                borderColor: mainColors.workload,
                data: null, 
                stack: 'Stack 1',
                name: 'orders'
            } 
        ]
    },
    activeDatasets: {
        hourly: null,
        daily: null,
        sectors: null 
    }
};

const mutations = {
    setState: (state, {key, value}) => {
        state[key] = value;
    },
    prepareDataset: (state, {key}) => {  
        state.activeDatasets[key] = state.datasets[key];    
    },
    setData: (state, {key, data}) => {  
        const array = [];
        
        for (const index in data) { 
            const elements = data[index];  

            state.datasets[key].forEach(element => {
                if(element.name === index) {
                    element.data = elements;
                }
            });
        }  
    },
    
    clear: state => { 
        state.activeDatasets.hourly = [];
        state.activeDatasets.daily = [];
        state.activeDatasets.sectors = [];
    },
    
    setDataset: (state, options) => {
        const {type, key, data} = options;
        state.datasets[type] = data || [];
    }
};
 
const actions = {
    async getCharts({dispatch, commit, state}, id) {
        await dispatch('getAreaChart', id);
        await dispatch('getHourlyChart', id);
        await dispatch('getDailyChart', id);

        commit('setState', {
            key: 'show',
            value: true
        }); 
    },

    async getAreaChart({commit}, id) {
        const response = await api.area(id);
        
        commit('setData', {
            key: 'sectors',
            data: response.data.data 
        }); 
    },
    async getHourlyChart({commit}, id) {
        const response = await api.hourly(id);  
         
        commit('setData', {
            key: 'hourly',
            data: response.data.data 
        }); 
    },
    async getDailyChart({commit}, id) {
        const response = await api.daily(id); 
         
        commit('setData', {
            key: 'daily',
            data: response.data.data 
        }); 
    }
};

const getters = {
    checkboxes: state => state.checkboxes,
    selected: state => state.selected, 
    activeDataset: state => key => state.activeDatasets[key],
    show: state => state.show
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
};